export const KPI_REGISTRY = {
  spend: {
    label: 'Importo speso',
    format: 'currency',
    resolve: ({ totals }) => totals?.spend || 0,
  },
  impressions: {
    label: 'Impression',
    format: 'number',
    resolve: ({ totals }) => totals?.impressions || 0,
  },
  reach: {
    label: 'Reach',
    format: 'number',
    resolve: ({ totals }) => totals?.reach || 0,
  },
  clicks: {
    label: 'Click',
    format: 'number',
    resolve: ({ totals }) => totals?.clicks || 0,
  },
  ctr: {
    label: 'CTR',
    format: 'percent',
    resolve: ({ totals }) =>
      totals?.impressions > 0
        ? (totals.clicks / totals.impressions) * 100
        : null,
  },
  cpm: {
    label: 'CPM',
    format: 'currency',
    resolve: ({ totals }) =>
      totals?.impressions > 0
        ? (totals.spend / totals.impressions) * 1000
        : null,
  },
};
